(function() { window.GUID_8b4d9dd2_1360_4b80_8ad3_b04718906f8d = { getGuid: function() { return "8b4d9dd2-1360-4b80-8ad3-b04718906f8d"; } }; })();
var CS;
(function (CS) {
    var Enumeration;
    (function (Enumeration) {
        let SurfaceCheckInResultEnum;
        (function (SurfaceCheckInResultEnum) {
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["Succes"] = 0] = "Succes";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["SuccesOpponent"] = 1] = "SuccesOpponent";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["AlreadyScanned"] = 2] = "AlreadyScanned";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["OpponentAlreadyScanned"] = 3] = "OpponentAlreadyScanned";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["MatchInFuture"] = 10] = "MatchInFuture";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["WrongTable"] = 11] = "WrongTable";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["MatchInFutureAndWrongTable"] = 12] = "MatchInFutureAndWrongTable";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["ErrorQR"] = 20] = "ErrorQR";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["ErrorSurfaceToEvent"] = 21] = "ErrorSurfaceToEvent";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["ErrorUserEventToEntity"] = 22] = "ErrorUserEventToEntity";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["MatchInPast"] = 23] = "MatchInPast";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["MatchInPastAndWrongTable"] = 24] = "MatchInPastAndWrongTable";
            SurfaceCheckInResultEnum[SurfaceCheckInResultEnum["NoMatchFound"] = 26] = "NoMatchFound";
        })(SurfaceCheckInResultEnum = Enumeration.SurfaceCheckInResultEnum || (Enumeration.SurfaceCheckInResultEnum = {}));
    })(Enumeration = CS.Enumeration || (CS.Enumeration = {}));
})(CS || (CS = {}));

//# sourceMappingURL=SurfaceCheckInResultEnum.pre.js.map
